import { Row, Tab } from '@rematter/ui-web';
import { LucideAlertCircle } from 'lucide-react';

export type TabWithWarningProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
  showWarning?: boolean;
};

export const TabWithWarning = ({
  label,
  selected,
  onClick,
  showWarning,
}: TabWithWarningProps) => (
  <Tab selected={selected} onClick={onClick} className="@TabWithWarning">
    <Row className="items-center gap-1.5">
      {label}
      {showWarning && (
        <LucideAlertCircle className="size-4 fill-warning text-white" />
      )}
    </Row>
  </Tab>
);
